<template>
<div class="test">
    <Swiper></Swiper>  
</div>
    

</template>

<script>
export default {
      components: {
             Nav: () => import("@/components/Test/Nav.vue"),
             Swiper: () => import("@/components/Test/swiper.vue"),
      }
}
</script>

<style scoped lang="scss">
    .test{
        margin-top: 100px
    }
</style>